import styled from 'styled-components'

export const NotFoundStyle = styled.div`
  background: var(--primaryColorLight);
  padding: 1rem;
  text-align: center;
  box-shadow: 0 0 2px 0px var(--primaryColor);
`
